// extracted by mini-css-extract-plugin
export default {"card":"style_card__UOOWu","card-image":"style_card-image__RX8FD","card-text-container":"style_card-text-container__KdtFC"};